import { render } from "./CreateNewUserPage.vue?vue&type=template&id=20a8089e&scoped=true"
import script from "./CreateNewUserPage.vue?vue&type=script&lang=js"
export * from "./CreateNewUserPage.vue?vue&type=script&lang=js"

import "./CreateNewUserPage.vue?vue&type=style&index=0&id=20a8089e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8089e"]])

export default __exports__